import React from 'react';
import { Box } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';
import type { SxProps, Theme } from '@mui/material/styles';
import SectionHeader from '../../SectionHeader';

interface EsgSectionProps {
  title: React.ReactNode;
  icon?: SvgIconComponent;
  description?: React.ReactNode;
  meta?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  id?: string;
  sx?: SxProps<Theme>;
}

/** One editorial dashboard section: rule + icon + label, then its content. */
const EsgSection: React.FC<EsgSectionProps> = ({ title, icon, description, meta, actions, children, id, sx }) => (
  <Box
    component="section"
    id={id}
    sx={[{ mb: { xs: 5, md: 6 }, minWidth: 0 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
  >
    <SectionHeader title={title} icon={icon} description={description} meta={meta} actions={actions} />
    {children}
  </Box>
);

export default EsgSection;
